import { ComponentType } from 'react';
import { FaJava } from 'react-icons/fa';
import { HiOutlineCode } from 'react-icons/hi';
import {
  SiAmazon,
  SiChakraui,
  SiDocker,
  SiDigitalocean,
  SiExpo,
  SiGoogleanalytics,
  SiGo,
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiJest,
  SiJetpackcompose,
  SiKotlin,
  SiMongodb,
  SiMysql,
  SiNestjs,
  SiNextdotjs,
  SiNodedotjs,
  SiPostgresql,
  SiPrisma,
  SiPython,
  SiRabbitmq,
  SiReact,
  SiRedis,
  SiRust,
  SiSpring,
  SiSqlite,
  SiSwift,
  SiTailwindcss,
  SiTauri,
  SiTypescript,
  SiVite,
} from 'react-icons/si';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IconComponent = ComponentType<any>;

const ICONS: Record<string, IconComponent> = {
  typescript: SiTypescript,
  javascript: SiJavascript,
  nextjs: SiNextdotjs,
  react: SiReact,
  reactnative: SiReact,
  kotlin: SiKotlin,
  nestjs: SiNestjs,
  nest: SiNestjs,
  nodejs: SiNodedotjs,
  node: SiNodedotjs,
  postgresql: SiPostgresql,
  postgres: SiPostgresql,
  mysql: SiMysql,
  mongodb: SiMongodb,
  sqlite: SiSqlite,
  redis: SiRedis,
  rabbitmq: SiRabbitmq,
  docker: SiDocker,
  aws: SiAmazon,
  amazon: SiAmazon,
  digitalocean: SiDigitalocean,
  tauri: SiTauri,
  rust: SiRust,
  python: SiPython,
  java: FaJava,
  spring: SiSpring,
  go: SiGo,
  golang: SiGo,
  swift: SiSwift,
  chakra: SiChakraui,
  chakraui: SiChakraui,
  tailwind: SiTailwindcss,
  tailwindcss: SiTailwindcss,
  expo: SiExpo,
  jetpackcompose: SiJetpackcompose,
  compose: SiJetpackcompose,
  jest: SiJest,
  vite: SiVite,
  html: SiHtml5,
  html5: SiHtml5,
  css: SiCss3,
  css3: SiCss3,
  ga: SiGoogleanalytics,
};

function normalize(name: string): string {
  return name
    .toLowerCase()
    .replace(/\.js$/, 'js')
    .replace(/[\s.\-_/]/g, '');
}

export function getTechIcon(name: string): IconComponent {
  return ICONS[normalize(name)] ?? HiOutlineCode;
}
